import { IntroScreenUIConfig } from "../../components/ui/intro-screen-ui";
import { SingleScenarioInfoConfig } from "../../components/ui/scenario-info-ui";
import GameManager from "../../cvp-webgames-core/GameManager";
import BaseScenarioPart from "../../cvp-webgames-core/Scenario/BaseScenarioPart";
import { VideoSegmentItem, SingleVideoSegmentItem } from "../../cvp-webgames-core/VideoSegment/VideoSegmentItem";
import { PreCacheItem, SinglePreCacheItem, PrecacheItemType } from "../../cvp-webgames-core/pre-caching/pre-cache-item";
import { PageType } from "../../misc/tools";
import { GameBaseScenario } from "../GameBaseScenario";
import { scenario1PivBadgeVideoSegments } from "../scenario1-piv-badge/scenario1-piv-badge";
import RmeTempHumComponentsStep0Component from "./components/rme-temp-hum-components-step0/rme-temp-hum-components-step0";
import RmeTempHumComponentsStep0Part1 from "./components/rme-temp-hum-components-step0/rme-temp-hum-components-step0-parts/rme-temp-hum-components-step0-part1";
import RmeTempHumComponentsStep1Component from "./components/rme-temp-hum-components-step1/rme-temp-hum-components-step1";
import RmeTempHumComponentsStep1Part1 from "./components/rme-temp-hum-components-step1/rme-temp-hum-components-step1-parts/rme-temp-hum-components-step1-part1";
import RmeTempHumComponentsStep2Component from "./components/rme-temp-hum-components-step2/RmeTempHumComponentsStep2Component";
import RmeTempHumComponentsStep2Part1 from "./components/rme-temp-hum-components-step2/rme-temp-hum-components-step2-parts/rme-temp-hum-components-step2-part1";

class Scenario8RmeTempHumVideoSegments extends VideoSegmentItem {
	public get title(): string {
		return 'Scenario 8 Rme Temp Hum';
    }
	public getItems(): SingleVideoSegmentItem[] {
		return [
			{
				key: 'Scenario 8 Video 1',
				src: process.env.PUBLIC_URL + '/assets/videos/scenario08/sc08-cinematic/cin-sc-8.mp4',
				chapterIds: [
					'Chapter 1'
				]
			},
			{
				key: 'MixedMedia',
				src: process.env.PUBLIC_URL + '/assets/videos/scenario08/sc08-mentor/mntr-sc-08.mp4', // change this
				chapterIds: [
					'step-2'// alan to update premiere file with audios lol at the end of the time code.
				]
			},
			{
				key: 'Feedback',
				src: process.env.PUBLIC_URL + '/assets/videos/scenario08/sc08-mentor/mntr-sc-08.mp4', // change this
				chapterIds: [
					'scenario8-4', //question 1 correct - don't delete comment!
					'scenario8-3', //question 1 incorrect - don't delete comment!
					'scenario8-5', //question 1 other option - don't delete comment!
					'scenario8-8',//question 2 correct - don't delete comment!
					'scenario8-7', //question 2 incorrect - don't delete comment!
					'scenario8-9', //question 2 other option - don't delete comment!
					'scenario8-12', //question 3 correct - don't delete comment!
					'scenario8-13', //question 3 incorrect - don't delete comment!
					'scenario8-16', //question 4 correct - don't delete comment!
					'scenario8-15', //question 4 incorrect - don't delete comment!
					'scenario8-17', //question 4 other option - don't delete comment!
					'scenario8-20', //question 5 correct - don't delete comment!
					'scenario8-19', //question 5 incorrect - don't delete comment!
					'scenario8-1', //scenario info 
					'scenario8-21' //scenario review 
				]
			}
		];
	}
}

export const scenario8RmeTempHumVideoSegments = new Scenario8RmeTempHumVideoSegments();

class Scenario8RmeTempHumAudioCaching extends PreCacheItem {
    public audioKeys = {
        question1: 'question1',
        question2: 'question2',
        question3: 'question3',
        question4: 'question4',
        question5: 'question5'
    };
	public getItems(): SinglePreCacheItem[] {
		return [
			{
				type: PrecacheItemType.Audio,
				key: this.audioKeys.question1,
				src: process.env.PUBLIC_URL + '/assets/voiceover/scenario-08/mentor/jcdst-mentor-vo-scn-08-04.mp3'
			},
			{
				type: PrecacheItemType.Audio,
				key: this.audioKeys.question2,
				src: process.env.PUBLIC_URL + '/assets/voiceover/scenario-08/mentor/jcdst-mentor-vo-scn-08-09.mp3'
			},
			{
				type: PrecacheItemType.Audio,
				key: this.audioKeys.question3,
				src: process.env.PUBLIC_URL + '/assets/voiceover/scenario-08/mentor/jcdst-mentor-vo-scn-08-15.mp3'
			},
			{
				type: PrecacheItemType.Audio,
				key: this.audioKeys.question4,
				src: process.env.PUBLIC_URL + '/assets/voiceover/scenario-08/mentor/jcdst-mentor-vo-scn-08-19.mp3'
			},
			{
				type: PrecacheItemType.Audio,
				key: this.audioKeys.question5,
				src: process.env.PUBLIC_URL + '/assets/voiceover/scenario-08/mentor/jcdst-mentor-vo-scn-08-24.mp3'
			}
		];
	}
}

export const scenario8RmeTempHumAudioCaching = new Scenario8RmeTempHumAudioCaching();

export default class Scenario8RmeTempHum extends GameBaseScenario {
	public comp1Step1FirstSelectedChoiceIndex: number = -1;
	public getMentorVideoURLs(): SingleVideoSegmentItem[] {
		return [
			scenario8RmeTempHumVideoSegments.getItemByKey('MixedMedia'),
			scenario8RmeTempHumVideoSegments.getItemByKey('Feedback'),
		] 
	}
	public getScenarioInfo(): SingleScenarioInfoConfig {
		return {
			scenarioId: PageType.Scenario8RmeTempHum,
			title: 'Reusable Medical Equipment (RME)',
			subtitle: 'Situation/Background',
			img: process.env.PUBLIC_URL + '/assets/images/scenarios/sample-image.png',
			description: `
				<p class="small-text" style="margin: 20px; text-align: center">
				After this learning activity you will be able to apply the Just Culture Decision Support Tool after an adverse event occurs.
				
				A thoracentesis tray was used in the ED, even after contamination from moisture was noted on several instruments, because no SPS staff member was available to provide another thoracentesis tray for use. When the temperature and humidity data was reviewed from the central database, the humidity was out of range for several days, but had been signed off as within range.
				</p>
			`,
			mentorVideoUrl: scenario8RmeTempHumVideoSegments.getItemByKey('Feedback').src,
			mentorChapterId: scenario8RmeTempHumVideoSegments.getItemByKey('Feedback').chapterIds[13]
		}
    }
	public resumeScenarioFromArea(areaIndx: number): void {
		switch(areaIndx) {
			case 0:
				(this.step0Component.parts[0] as RmeTempHumComponentsStep0Part1).section2();
				break;
			case 1:
				(this.step0Component.parts[0] as RmeTempHumComponentsStep0Part1).section3();
				break;
			case 2:
				(this.step1Component.parts[0] as RmeTempHumComponentsStep1Part1).section2();
				break;
			case 3:
				(this.step1Component.parts[0] as RmeTempHumComponentsStep1Part1).section3();
				break;
			case 4:
				(this.step2Component.parts[0] as RmeTempHumComponentsStep2Part1).section1();
				break;
			case 5:
				(this.step2Component.parts[0] as RmeTempHumComponentsStep2Part1).section2();
				break;
			case 6:
				(this.step1Component.parts[0] as RmeTempHumComponentsStep1Part1).section1();
				break;
		}
	}

	//VALUES BELOW ARE FOR DEBUG PURPOSES IN CASE STEP 1 is SKIPPED
	// public comp1Step1FirstSelectedChoiceIndex: number = 0;
	public scenarioId(): PageType {
		return PageType.Scenario8RmeTempHum;
    }

	private video: SingleVideoSegmentItem = scenario8RmeTempHumVideoSegments.getItemByKey('Scenario 8 Video 1');
	public getScenarioVideoURL(): string {
		return this.video.src;
	}
	public introScreenInfo(): IntroScreenUIConfig {
		return {
			title: 'Reusable Medical Equipment',
			subtitle: 'Incident Report',
			name: 'Joan',
			position: 'ED Nurse',
			time: 'Day Shift',
			place: 'Emergency Department',
			desc: `Use of a thoracentesis tray after contamination is noted (moisture evident on several instruments). Delay 
			in Sterile Processing Services (SPS) delivery of another sterile thoracentesis tray (reports no SPS staff 
			member available to bring the tray to the ED)`,
			repeat: 'No',
			okButton: 'Continue'
		}
	}

	private step0Component = new RmeTempHumComponentsStep0Component({
		scenario: this,
		onDone: () => {
			this.goToStep1Component();
		}
	})

	private step1Component = new RmeTempHumComponentsStep1Component({
		scenario: this,
		onDone: () => {
			this.goToStep2Component();
		}
	})

	private step2Component = new RmeTempHumComponentsStep2Component({
		scenario: this,
		onDone: () => {
			this.uiWrapper.displayAAR();
		}
	})

	private parts: BaseScenarioPart<GameBaseScenario>[] = [].concat(this.step0Component.parts)
		.concat(this.step1Component.parts)
		.concat(this.step2Component.parts);

	constructor(gameManager: GameManager, scenarioName: string) {
		super(gameManager, scenarioName);
		this._setupStep0Component();
		this._setupStep1Component();
		this._setupStep2Component();
	}

	start() {
		this.goToStep0Component();
	}

	private _setupStep0Component() {
		this.step0Component.config.part1Config = {
			chapter: () => {
				return this.video.chapterIds[0];
			},
			videoUrl: this.video.src
		}
	}

	private _setupStep1Component() {
		this.step1Component.config.part1Config = {
			chapter: () => {
				return this.video.chapterIds[0];
			},
			videoUrl: this.video.src
		}
	}

	private _setupStep2Component() {
		this.step2Component.config.part1Config = {
			videoUrl: this.video.src
		}
	}

	public getParts(): BaseScenarioPart<GameBaseScenario>[] {
		return this.parts;
	}

	public getSoundPath(fileName: string): string {
		return process.env.PUBLIC_URL + '/assets/audio/scenario1/' + fileName + '.ogg';
	}

	goToStep0Component() {
		this.step0Component.start();
	}

	goToStep1Component() {
		this.step1Component.start();
	}

	goToStep2Component() {
		this.step2Component.start();
	}
}